import {
  Box, ButtonBase, Typography, useTheme
} from '@mui/material';
import React from 'react';
import MenuItem from './MenuItem';

type SubItem = Omit<MenuItem, 'menuItems'>;

interface SidebarMenuSubItemProps {
  menuItem: SubItem;
  collapse: boolean;
  closeParent: () => void;
  // eslint-disable-next-line no-unused-vars
  onRouteSelected: (menuItem: SubItem) => void;
}

const SidebarMenuSubItem: React.FC<React.PropsWithChildren<SidebarMenuSubItemProps>> = (props) => {
  const {
    menuItem, onRouteSelected, collapse, closeParent,
  } = props;
  const theme = useTheme();
  const handleRouteSelected = typeof menuItem.route === 'string' ? onRouteSelected : menuItem.route;

  const _handleButtonClicked = () => {
    handleRouteSelected(menuItem);
    closeParent();
  };

  return (
    <Box
      sx={{
        ...(collapse && {
          borderBottom: `1px solid ${theme.palette.divider}`,
        }),
      }}
    >
      <ButtonBase
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          height: theme.spacing(6),
          borderRadius: theme.spacing(0.5),
          padding: `${theme.spacing(1.5)} ${theme.spacing(2)} ${theme.spacing(1.5)} ${theme.spacing(4)}`,
          '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
          },
          ...(collapse && {
            padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
            borderRadius: theme.spacing(0.5),
          }),
          ...(menuItem.isActive && {
            color: theme.palette.primary.main,
          }),
        }}
        onClick={() => _handleButtonClicked()}
      >
        <Box
          data-testid="left icon"
          component="span"
          sx={{
            flexGrow: 0,
            width: theme.spacing(3),
            height: theme.spacing(3),
          }}
        >
          {menuItem.leftIcon}
        </Box>

        <Typography
          data-testid={menuItem.title}
          variant="subtitle2"
          align="left"
          sx={{
            flexGrow: 1,
            paddingLeft: theme.spacing(2),
            fontWeight: 'bold',
          }}
        >
          {menuItem.title}
        </Typography>
      </ButtonBase>
    </Box>
  );
};

export default SidebarMenuSubItem;
